export const gamesQueryKey = { all: ['games'] as const };

export const sandboxQueryKey = {
  current: ['sandbox'] as const, // the sandbox's own detail/state (unscoped); content is scoped under [gameCode, sandboxCode]
  detail: (id: string) => [...sandboxQueryKey.current, id],
  // scope leads: [gameCode, ...] so invalidating a game prunes its sandbox list
  list: (gameCode: string) => [gameCode, 'sandboxes'] as const,
};
